import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import Card from "../components/ui/Card";
import DeedPool from "../components/ui/DeedPool";
import { useAppState } from "../context/AppStateContext";

export default function DailyDeedPage() {
  const { state, dailyDeed, deedCompleted, actions } = useAppState();

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="space-y-4">
      <Card title="Daily Islamic deed" icon={Sparkles} right={deedCompleted ? <span className="text-xs">Done ✓</span> : null}>
        <div className="text-sm text-zinc-700 dark:text-zinc-200">{dailyDeed}</div>
        <button
          onClick={actions.toggleDeedComplete}
          className={
            "mt-3 w-full rounded-xl py-3 font-semibold ring-1 transition " +
            (deedCompleted
              ? "bg-white dark:bg-zinc-900/50 ring-black/10 dark:ring-white/10"
              : "bg-zinc-900 dark:bg-white text-white dark:text-zinc-900 ring-zinc-900 dark:ring-white")
          }
        >
          {deedCompleted ? "Mark as not done" : "Mark as done"}
        </button>
        <div className="mt-4 text-xs text-zinc-500 dark:text-zinc-400">You can customize the deed pool in this page.</div>
      </Card>

      <Card title="Customize deed pool" icon={Sparkles}>
        <DeedPool items={state.dailyDeeds.pool || []} onAdd={actions.addDeedToPool} onRemove={actions.removeDeedFromPool} />
      </Card>
    </motion.div>
  );
}
